import React from 'react'

const User = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <path
        d="M16.6729 15.625C20.1246 15.625 22.9229 18.4232 22.9229 21.875C22.9229 22.4502 22.457 22.9168 21.8818 22.917C21.3065 22.917 20.8398 22.4503 20.8398 21.875C20.8398 19.5738 18.974 17.708 16.6729 17.708H8.33984C6.03866 17.708 4.17285 19.5738 4.17285 21.875C4.17285 22.4502 3.70698 22.9168 3.13184 22.917C2.55654 22.917 2.08984 22.4503 2.08984 21.875C2.08984 18.4232 4.88806 15.625 8.33984 15.625H16.6729ZM12.5068 2.08398C15.6708 2.08416 18.2354 4.64945 18.2354 7.81348C18.2352 10.9774 15.6707 13.5418 12.5068 13.542C9.34281 13.542 6.77752 10.9775 6.77734 7.81348C6.77734 4.64934 9.3427 2.08398 12.5068 2.08398ZM12.5068 4.16699C10.4933 4.16699 8.86035 5.79994 8.86035 7.81348C8.86053 9.82687 10.4934 11.459 12.5068 11.459C14.5201 11.4588 16.1522 9.82676 16.1523 7.81348C16.1523 5.80005 14.5202 4.16717 12.5068 4.16699Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default User
